








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-save'
})
export default class ISave extends Vue {

  @Prop({type: [String], default: '#C1C1C1'}) protected color!: string
}

